import { FC } from 'react';
import { getSubdomain } from 'utils/helpers/routing';
import { useActiveClientContext } from 'store/active-client';
import HeaderOperator from './HeaderOperator';
import HeaderClient from './HeaderClient';

const Header: FC = () => {
  const { client } = useActiveClientContext();

  // If there is no active client set - load operators menu
  // Else - load the client menu
  const isOperatorMode = getSubdomain() === 'operators' && client?.id === null;

  if (isOperatorMode) return <HeaderOperator />;
  return <HeaderClient />;
};

export default Header;
